import React from 'react';
import Icon from '../../../components/AppIcon';

const EVENT_TYPES = {
  Loncheado: { color: '#22c55e', bg: '#22c55e20', label: 'Loncheado', dot: '🟢' },
  Entrega: { color: '#eab308', bg: '#eab30820', label: 'Entrega', dot: '🟡' },
  Comunión: { color: '#3b82f6', bg: '#3b82f620', label: 'Comunión', dot: '🔵' },
  Boda: { color: '#a855f7', bg: '#a855f720', label: 'Boda', dot: '🟣' },
  Feria: { color: '#f97316', bg: '#f9731620', label: 'Feria', dot: '🟠' },
  Urgente: { color: '#ef4444', bg: '#ef444420', label: 'Urgente', dot: '🔴' },
  Pendiente: { color: '#6b7280', bg: '#6b728020', label: 'Pendiente', dot: '⚫' },
  EVENTO: { color: '#D6EF4E', bg: '#D6EF4E20', label: 'Evento', dot: '🟡' },
  TIENDA: { color: '#3A7F6B', bg: '#3A7F6B20', label: 'Tienda', dot: '🟢' },
  FERIA: { color: '#f97316', bg: '#f9731620', label: 'Feria', dot: '🟠' },
  PRIVADO: { color: '#a855f7', bg: '#a855f720', label: 'Privado', dot: '🟣' },
};

const ESTADOS = {
  PROGRAMADO: { color: '#C9A24D', bg: '#C9A24D20', label: 'Programado' },
  Pendiente: { color: '#C9A24D', bg: '#C9A24D20', label: 'Pendiente' },
  Confirmado: { color: '#3A7F6B', bg: '#3A7F6B20', label: 'Confirmado' },
  'En preparación': { color: '#3b82f6', bg: '#3b82f620', label: 'En preparación' },
  'En proceso': { color: '#a855f7', bg: '#a855f720', label: 'En proceso' },
  REALIZADO: { color: '#3A7F6B', bg: '#3A7F6B20', label: 'Realizado' },
  Finalizado: { color: '#3A7F6B', bg: '#3A7F6B20', label: 'Finalizado' },
  CANCELADO: { color: '#ef4444', bg: '#ef444420', label: 'Cancelado' },
  Cancelado: { color: '#ef4444', bg: '#ef444420', label: 'Cancelado' },
};

export const getEventTypeStyle = (tipo) => EVENT_TYPES?.[tipo] || EVENT_TYPES?.['Pendiente'];
export const getEstadoStyle = (estado) => ESTADOS?.[estado] || ESTADOS?.['Pendiente'];

const AdvancedFilters = ({ filters, onFilterChange, empleados, clientes, ubicaciones }) => {
  const quickDates = [
    { label: 'Hoy', action: () => {
      const t = new Date()?.toISOString()?.split('T')?.[0];
      onFilterChange('dateFrom', t); onFilterChange('dateTo', t);
    }},
    { label: 'Mañana', action: () => {
      const t = new Date(); t?.setDate(t?.getDate() + 1);
      const d = t?.toISOString()?.split('T')?.[0];
      onFilterChange('dateFrom', d); onFilterChange('dateTo', d);
    }},
    { label: 'Esta Semana', action: () => {
      const now = new Date();
      const mon = new Date(now); mon?.setDate(now?.getDate() - now?.getDay() + 1);
      const sun = new Date(mon); sun?.setDate(mon?.getDate() + 6);
      onFilterChange('dateFrom', mon?.toISOString()?.split('T')?.[0]);
      onFilterChange('dateTo', sun?.toISOString()?.split('T')?.[0]);
    }},
    { label: 'Próx. Semana', action: () => {
      const now = new Date();
      const mon = new Date(now); mon?.setDate(now?.getDate() - now?.getDay() + 8);
      const sun = new Date(mon); sun?.setDate(mon?.getDate() + 6);
      onFilterChange('dateFrom', mon?.toISOString()?.split('T')?.[0]);
      onFilterChange('dateTo', sun?.toISOString()?.split('T')?.[0]);
    }},
    { label: 'Este Mes', action: () => {
      const now = new Date();
      const first = new Date(now.getFullYear(), now.getMonth(), 1)?.toISOString()?.split('T')?.[0];
      const last = new Date(now.getFullYear(), now.getMonth() + 1, 0)?.toISOString()?.split('T')?.[0];
      onFilterChange('dateFrom', first); onFilterChange('dateTo', last);
    }},
  ];

  const tiposEvento = ['Loncheado', 'Entrega', 'Comunión', 'Boda', 'Feria', 'Urgente', 'Pendiente', 'EVENTO', 'TIENDA', 'FERIA', 'PRIVADO'];
  const estadosOpts = ['PROGRAMADO', 'Pendiente', 'Confirmado', 'En preparación', 'En proceso', 'REALIZADO', 'Finalizado', 'CANCELADO', 'Cancelado'];

  return (
    <div className="bg-[#1A1A1A] rounded-xl border border-white/8 p-4 space-y-3">
      {/* Quick date buttons */}
      <div className="flex flex-wrap gap-2">
        {quickDates?.map(qd => (
          <button key={qd?.label} onClick={qd?.action}
            className="px-3 py-1.5 text-xs font-oranienbaum rounded-lg bg-white/5 hover:bg-[#D6EF4E]/10 hover:text-[#D6EF4E] border border-white/10 hover:border-[#D6EF4E]/30 transition-all duration-150">
            {qd?.label}
          </button>
        ))}
        <button onClick={() => onFilterChange('reset', null)}
          className="px-3 py-1.5 text-xs font-oranienbaum rounded-lg bg-white/5 hover:bg-red-500/10 hover:text-red-400 border border-white/10 hover:border-red-500/30 transition-all duration-150 ml-auto">
          <Icon name="X" size={12} className="inline mr-1" />Limpiar
        </button>
      </div>
      {/* Filter row */}
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
        <input
          type="text"
          placeholder="Buscar cliente..."
          value={filters?.search || ''}
          onChange={e => onFilterChange('search', e?.target?.value)}
          className="col-span-2 sm:col-span-2 bg-[#111] border border-white/10 rounded-lg px-3 py-2 text-xs font-oranienbaum text-white placeholder-white/30 focus:outline-none focus:border-[#D6EF4E]/50"
        />
        <select value={filters?.empleadoId || 'all'} onChange={e => onFilterChange('empleadoId', e?.target?.value)}
          className="bg-[#111] border border-white/10 rounded-lg px-3 py-2 text-xs font-oranienbaum text-white focus:outline-none focus:border-[#D6EF4E]/50">
          <option value="all">Todos empleados</option>
          {empleados?.map(emp => <option key={emp?.id} value={emp?.id}>{emp?.nombre}</option>)}
        </select>
        <select value={filters?.tipoServicio || 'all'} onChange={e => onFilterChange('tipoServicio', e?.target?.value)}
          className="bg-[#111] border border-white/10 rounded-lg px-3 py-2 text-xs font-oranienbaum text-white focus:outline-none focus:border-[#D6EF4E]/50">
          <option value="all">Tipo evento</option>
          {tiposEvento?.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
        <select value={filters?.estado || 'all'} onChange={e => onFilterChange('estado', e?.target?.value)}
          className="bg-[#111] border border-white/10 rounded-lg px-3 py-2 text-xs font-oranienbaum text-white focus:outline-none focus:border-[#D6EF4E]/50">
          <option value="all">Estado</option>
          {estadosOpts?.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={filters?.ubicacion || 'all'} onChange={e => onFilterChange('ubicacion', e?.target?.value)}
          className="bg-[#111] border border-white/10 rounded-lg px-3 py-2 text-xs font-oranienbaum text-white focus:outline-none focus:border-[#D6EF4E]/50">
          <option value="all">Provincia</option>
          {ubicaciones?.map(u => <option key={u} value={u}>{u}</option>)}
        </select>
        <input type="date" value={filters?.dateFrom || ''} onChange={e => onFilterChange('dateFrom', e?.target?.value)}
          className="bg-[#111] border border-white/10 rounded-lg px-3 py-2 text-xs font-oranienbaum text-white focus:outline-none focus:border-[#D6EF4E]/50"
          placeholder="Desde" />
        <input type="date" value={filters?.dateTo || ''} onChange={e => onFilterChange('dateTo', e?.target?.value)}
          className="bg-[#111] border border-white/10 rounded-lg px-3 py-2 text-xs font-oranienbaum text-white focus:outline-none focus:border-[#D6EF4E]/50"
          placeholder="Hasta" />
      </div>
    </div>
  );
};

export default AdvancedFilters;
